export default __webpack_public_path__ + "static/media/AElement.d236b6b2.jpg";